module.exports = __webpack_public_path__ + "img/male_education.248486c7.png";